import React from 'react'
import Helmet from 'react-helmet'

import sponsor from './sponsor.jpg'
import support from './support.jpg'

const sponsorshipURL = 'https://cohootsfdn.org/ycms/#interest-form'
const contactEmail = 'mailto:contact@cohootsfdn.org'

const SponsorshipPage = props => {
  return (
    <div>
      <section className="actions grid-x grid-padding-x">
        <div className="cell small-12 medium-auto shrink">
          <h2>Sponsor an Event:</h2>
        </div>
        {/* <div className="cell auto shrink">
          <a className="button" href={sponsorshipURL}>
            See Sponsorship Options
          </a>
        </div> */}
      </section>

      <section className="teal grid-x grid-padding-x align-justify" id="facts">
        <div className="cell medium-6">
          <h2>Help Support Youth Entrepreurship</h2>
          <p>
            We want to make an impact, but we need your help. The Youth
            ChangeMaker Summit is a 3-day immersion for high school students
            that teaches them how they can change the world through business
            creation.
          </p>
          <p>
            To create the Arizona we want, we must empower all students to build
            solutions to the problems they experience in their home communities.
          </p>
          <p>
            During the summit, students imagine, plan, and pitch a business
            solution that will help to transform their community.
          </p>
          <p>
            If you are interested in sponsoring this event and empowering the
            students in your community, please let us know!{' '}
            <a href={sponsorshipURL}>Fill out our interest form</a> or{' '}
            <a href={contactEmail}>send us an email today</a>.
          </p>
        </div>
        <div className="cell medium-6 small-first">
          <img
            src={sponsor}
            alt="Guest speaker talking to students"
            style={{ borderRadius: '8px' }}
          />
        </div>
      </section>

      <section className="dark-gray grid-x grid-padding-x align-middle tac">
        <div className="cell medium-6">
          <img
            src={support}
            alt="Students working together"
            style={{ borderRadius: '8px' }}
          />
        </div>
        {<div className="cell medium-6 small-first">
          <h2>Ready to support Youth ChangeMaker Summit?</h2>
          <a className="button" href={sponsorshipURL}>
            Sponsorship Interest Form
          </a>
        </div>}
      </section>
      <Helmet
        title="Sponsorship | YCMSummit"
        meta={[
          {
            name: 'og:title',
            content: 'Sponsorship | Youth ChangeMaker Summit',
          },
          {
            name: 'og:description',
            content:
              'Youth ChangeMaker Summit is an entrepreneurship event for high school students.',
          },
          {
            name: 'og:image',
            content: '/img/bg-img.jpg',
          },
          {
            name: 'twitter:card',
            content: 'summary',
          },
          {
            name: 'twitter:site',
            content: '@ycmsummit',
          },
          {
            name: 'og:image',
            content: 'https://ycmsummit.com/img/register-social.jpg',
          },
          {
            name: 'og:image:width',
            content: '600',
          },
          {
            name: 'og:image:height',
            content: '400',
          },
        ]}
      />
    </div>

    // <Helmet
    //   // title={site.siteMetadata.title}
    //   meta={[
    //     {
    //       name: 'description',
    //       content:
    //         'A reference site for iOS developers to quickly find links to relevant documentation and examples.',
    //     },
    //     {
    //       name: 'keywords',
    //       content:
    //         'ios, mobile, iphone, apps, developer, software development',
    //     },

    //     { name: 'twitter:card', content: 'summary' },
    //     { name: 'twitter:site', content: '@iosdevrecipes' },
    //     {
    //       name: 'twitter:title',
    //       content: 'iOS Dev Recipes',
    //     },
    //     {
    //       name: 'twitter:description',
    //       content: 'A reference site for iOS developers.',
    //     },
    //     {
    //       name: 'twitter:image',
    //       content: 'https://www.iosdev.recipes/img/logos/logo-2048.png',
    //     },
    //   {
    //     name: 'og:title',
    //     content: site.siteMetadata.title,
    //   },
    //   {
    //     name: 'og:description',
    //     content:
    //       'A reference site for iOS developers to quickly find links to relevant documentation and examples.',
    //   },
    //   {
    //     name: 'og:image',
    //     content: 'https://www.iosdev.recipes/img/logos/logo-2048.png',
    //   },
    // ]}
    // />
  )
}

export default SponsorshipPage

export const query = graphql`
  query SponsorshipPageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/sponsorship/index.js